var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['block.cmpVideoCollection'] = (function () {
    'use strict';

    const initialize = (widget) => {

        const collapse = widget.querySelector(".cmp--videoCollection__collapse");
        const button = collapse.querySelector(".cmp--videoCollection__collapse__toggle button");
        const content = collapse.querySelector(".cmp--videoCollection__collapse__content");

        button.addEventListener("click", function (event) {
            if (button.getAttribute("aria-expanded") == "false") {
                content.style.display = "block";
                button.setAttribute("aria-expanded", true);
            }
            else {
                content.style.display = "none";
                button.setAttribute("aria-expanded", false);
            }
        });
    }

    return {
        initialize
    };

})();